module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nvar isFilterField = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\nisFilterField = !!formMapping.fieldConfig.isFilterField;\n}\n// TODO ATOM TYPE\nif(model.isMultiCheckbox){\n// prepare config\n// TODO group config?!\nvar renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};\nvar groupConfig = renderConfig.groupEntries || {};\ngroupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);\nvar childConfig = renderConfig.optionEntries || {};\nchildConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);\nvar isGrouped = !!groupConfig.name;\n// prepare user-lang\nvar langCode;\nif(storage.user && storage.user.data && storage.user.data.langCode){\nlangCode = storage.user.data.langCode;\n}\n// prepare source-data-flag\nvar dataAttributeKey;\nif(!!model.atom && !!model.atom.dataType){\ndataAttributeKey = model.atom.dataType + '-data';\n} else {\ndataAttributeKey = 'data';\n}\n// prepare options\nvar options = [];\nif(Array.isArray(model[dataAttributeKey])){\noptions = model[dataAttributeKey];\n}\nelse if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){\noptions = model[dataAttributeKey].options;\n}\n// prepare default entry\nif(renderConfig.defaultOptionEntry){\nvar entry = {};\nif(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){\nentry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\nelse {\nentry[childConfig.name] = renderConfig.defaultOptionEntry.name;\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\noptions.unshift(entry);\n}\nif(!!options){\n//        {\n//            \"groupEntries\": {\n//                  \"name\": \"path\",\n//                  \"selectable\": false,\n//                  \"valuePrefix\": \"routeID\"\n//            }\n//        }\nvar groupFound = false;\nvar optionValue;\nvar optionName;\nvar optionSelected;\nvar optionConfig;\nvar firstOptionInCharge = true;\nvar optionID;\n%>\n<%#-JSON.stringify({ groupConfig: groupConfig, childConfig: childConfig, data: model[dataAttributeKey] })%>\n<div data-field-code=\"<%= model.fieldCode %>\" >\n<%\nutils.forEach(options, function(child, childIndex){\noptionID = model.componentIndex + '_' + model.fieldCode + '_' + childIndex;\n// estimate right config for the actual child\nif(firstOptionInCharge && renderConfig.defaultOptionEntry)  optionConfig = childConfig;\nelse if(childIndex == 0 && groupConfig.selectable)          optionConfig = groupConfig;\nelse                                                        optionConfig = childConfig;\n// define option name\nif(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][optionConfig.name]){\noptionName = child.lang[storage.user.data.langCode][optionConfig.name];\n} else if (!!child[optionConfig.name]) {\noptionName = child[optionConfig.name];\n} else {\noptionName = '-NO-NAME-FOUND-';\n}\n// define options' value\noptionValue = (optionConfig.valuePrefix || '') + child[optionConfig.value];\n// define if option is selected\nif(utils.isCollection(model.dataJSON)) {\noptionSelected = utils.indexOf(model.dataJSON, optionValue) >= 0;\n} else {\noptionSelected = !!child.defaultSelected;\n}\n%>\n<div class=\"option\">\n<input id=\"<%= optionID %>\" data-value=\"<%= optionValue %>\" type=\"checkbox\" <% if(optionSelected){ %>CHECKED<% } %><%- (disabled ? 'disabled=\"disabled\"' : ''); %>/>\n<label for=\"<%= optionID %>\"><%= optionName %></label>\n</div>\n<%\nfirstOptionInCharge = false;\n});\n%>\n</div>\n<%\n}\n} else if(isFilterField){\n%>\n<%- include('./toggle', { model: model, formMapping: formMapping }); %>\n<%\n} else {\n%>\n<div>\n<input data-field-type=\"checkbox\" data-field-code=\"<%= model.fieldCode %>\" type=\"checkbox\" <% if(model.dataINT > 0){ %>CHECKED<% } %><%- (disabled ? 'disabled=\"disabled\"' : ''); %>/>\n<% if(model.label && isFilterField){ %>\n<label><%= model.label %></label>\n<% } %>\n<div class=\"description\"><%= model.description %></div>\n</div>\n<%\n}\n%>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\checkbox.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
var isFilterField = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
isFilterField = !!formMapping.fieldConfig.isFilterField;
}
// TODO ATOM TYPE
if(model.isMultiCheckbox){
// prepare config
// TODO group config?!
var renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};
var groupConfig = renderConfig.groupEntries || {};
groupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);
var childConfig = renderConfig.optionEntries || {};
childConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);
var isGrouped = !!groupConfig.name;
// prepare user-lang
var langCode;
if(storage.user && storage.user.data && storage.user.data.langCode){
langCode = storage.user.data.langCode;
}
// prepare source-data-flag
var dataAttributeKey;
if(!!model.atom && !!model.atom.dataType){
dataAttributeKey = model.atom.dataType + '-data';
} else {
dataAttributeKey = 'data';
}
// prepare options
var options = [];
if(Array.isArray(model[dataAttributeKey])){
options = model[dataAttributeKey];
}
else if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){
options = model[dataAttributeKey].options;
}
// prepare default entry
if(renderConfig.defaultOptionEntry){
var entry = {};
if(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){
entry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
else {
entry[childConfig.name] = renderConfig.defaultOptionEntry.name;
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
options.unshift(entry);
}
if(!!options){
//        {
//            "groupEntries": {
//                  "name": "path",
//                  "selectable": false,
//                  "valuePrefix": "routeID"
//            }
//        }
var groupFound = false;
var optionValue;
var optionName;
var optionSelected;
var optionConfig;
var firstOptionInCharge = true;
var optionID;

    ; __line = 66
    ; __append("\n")
    ; __line = 67
    ; __append("\n<div data-field-code=\"")
    ; __line = 68
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\" >\n")
    ; __line = 69
    ; 
utils.forEach(options, function(child, childIndex){
optionID = model.componentIndex + '_' + model.fieldCode + '_' + childIndex;
// estimate right config for the actual child
if(firstOptionInCharge && renderConfig.defaultOptionEntry)  optionConfig = childConfig;
else if(childIndex == 0 && groupConfig.selectable)          optionConfig = groupConfig;
else                                                        optionConfig = childConfig;
// define option name
if(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][optionConfig.name]){
optionName = child.lang[storage.user.data.langCode][optionConfig.name];
} else if (!!child[optionConfig.name]) {
optionName = child[optionConfig.name];
} else {
optionName = '-NO-NAME-FOUND-';
}
// define options' value
optionValue = (optionConfig.valuePrefix || '') + child[optionConfig.value];
// define if option is selected
if(utils.isCollection(model.dataJSON)) {
optionSelected = utils.indexOf(model.dataJSON, optionValue) >= 0;
} else {
optionSelected = !!child.defaultSelected;
}

    ; __line = 92
    ; __append("\n<div class=\"option\">\n<input id=\"")
    ; __line = 94
    ; __append(escapeFn( optionID ))
    ; __append("\" data-value=\"")
    ; __append(escapeFn( optionValue ))
    ; __append("\" type=\"checkbox\" ")
    ;  if(optionSelected){ 
    ; __append("CHECKED")
    ;  } 
    ; __append( (disabled ? 'disabled="disabled"' : '') )
    ; __append("/>\n<label for=\"")
    ; __line = 95
    ; __append(escapeFn( optionID ))
    ; __append("\">")
    ; __append(escapeFn( optionName ))
    ; __append("</label>\n</div>\n")
    ; __line = 97
    ; 
firstOptionInCharge = false;
});

    ; __line = 100
    ; __append("\n</div>\n")
    ; __line = 102
    ; 
}
} else if(isFilterField){

    ; __line = 105
    ; __append("\n")
    ; __line = 106
    ; __append( include('./toggle', { model: model, formMapping: formMapping }) )
    ; __append("\n")
    ; __line = 107
    ; 
} else {

    ; __line = 109
    ; __append("\n<div>\n<input data-field-type=\"checkbox\" data-field-code=\"")
    ; __line = 111
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\" type=\"checkbox\" ")
    ;  if(model.dataINT > 0){ 
    ; __append("CHECKED")
    ;  } 
    ; __append( (disabled ? 'disabled="disabled"' : '') )
    ; __append("/>\n")
    ; __line = 112
    ;  if(model.label && isFilterField){ 
    ; __append("\n<label>")
    ; __line = 113
    ; __append(escapeFn( model.label ))
    ; __append("</label>\n")
    ; __line = 114
    ;  } 
    ; __append("\n<div class=\"description\">")
    ; __line = 115
    ; __append(escapeFn( model.description ))
    ; __append("</div>\n</div>\n")
    ; __line = 117
    ; 
}

    ; __line = 119
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\checkbox.ejs

}